import { STATIC_ASSETS_PATH } from '~/nasa_ui/constants';
import { CosmicSystem, EsocApplication } from '~/nasa_ui/types/cosmic/system';
export const getAssetPath = (appName) => {
    let cosmicSystem = null;
    if (Object.values(EsocApplication).includes(appName)) {
        cosmicSystem = CosmicSystem.ESOC;
    }
    else {
        throw new Error(`Asset path ${cosmicSystem}/${appName} is not supported by getAssetPath.`);
    }
    return `${STATIC_ASSETS_PATH}/${cosmicSystem.toLowerCase()}/${appName.toLowerCase()}`;
};
export const getAssetLogoPath = (fileName) => {
    return `${STATIC_ASSETS_PATH}/logos/${fileName}`;
};
export const getBaseImagePath = () => {
    return `${STATIC_ASSETS_PATH}/images`;
};
